import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { MarketEditorData } from "../../state/Markets/EditorData";


const updateMarketsEditorData: Reducer<MarketEditorData> = (state: MarketEditorData = new MarketEditorData(), action: Action<ActionType, MarketEditorData>) => {
  switch (action.type) {
    case ActionType.MARKETS_EDITOR_DATA_RESET:
      return new MarketEditorData();
    case ActionType.MARKETS_EDITOR_DATA_FETCHED:
      return { ...state, marketData: action.data };
    case ActionType.MARKETS_EDITOR_DATA_COPIED:
      return { ...state, marketData: { ...action.data} };
    case ActionType.MARKETS_EDITOR_DATA_UPDATED:
      return { ...state, marketData: { ...state.marketData, ...action.data } };
    case ActionType.MARKETS_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.MARKETS_EDITOR_DATA_VALIDATED:
      return { ...state, validation: action.data };
    default:
      return state;
  }
};

export default updateMarketsEditorData;